import { AppBar, Box, Button, Divider, Card, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Grid2, IconButton, List, ListItem, ListItemText, Paper, Slide, Table, TableCell, TableRow, Toolbar, Typography, tableCellClasses } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import SignInDialog from '../../components/common/SignInDialog';
import api from '../../redux/features/auth/axiosAuthHelper';
import { logout, refreshAccessToken } from '../../redux/features/auth/authSlice';
import colorConfigs from '../../configs/colorConfigs';
import { TransitionProps } from '@mui/material/transitions';
import assets from '../../assets';
import RareButton from '../../components/common/buttons/RareButton';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import FactoryIcon from '@mui/icons-material/Factory';
import EmailIcon from '@mui/icons-material/Email';
import versionConfig from '../../configs/versionConfig';

type Props = {}


const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AboutPage = (props: Props) => {
  const productName = "OT-Scan web portal"
  const version = versionConfig.version
  const manufacturedate = versionConfig.manufactureDate
  const address = "Premier Biotech LLC"
  const address2 = "725 Kasota Ave, SE Minneapolis, MN 55414, USA"
  // const address3 = "Address3"
  const UDI = `(01)${versionConfig.UDIDI}(8012)${versionConfig.UDIPI}`

  const authData = useSelector((state: RootState) => state.auth);


  return authData.isAuthenticated == false ? (
    <SignInDialog isAuthenticated={authData.isAuthenticated} />
  ) : authData.isAuthenticated ? (
    <div data-testid="div-7s5j" style={{ overflowX: "hidden", maxHeight: `100%`, minHeight: `100%`, maxWidth: `100%`, minWidth: `100%`, margin: "auto" }}>

      <div data-testid="div-d3fd" style={{ display: "flex", height: "100%", width: "100%", maxWidth: `100%`, minWidth: `100%`, }}>

        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ m: 0, height: "100%", width: "100%", maxWidth: `100%`, minWidth: `100%`, }}
        >
          <Grid item xs={3} sx={{ m: 0, p: 0, maxWidth: `100%`, minWidth: `100%` }}>
            <Box data-testid="Box-smji" sx={{ m: 0, p: { xs: 1, md: 1.5 }, height: "100%", overflowY: "auto", marginRight: 0, display: 'flex', flexDirection: 'column', overflowX: "hidden", maxWidth: `93vw`, minWidth: `100%` }}>

              <Typography data-testid="Typography-wgvv" component="h1" align="center" fontWeight={700} fontSize={28} color={colorConfigs.tables.headBg} sx={{ pt: 1.5, mb: 2, px: 7 }}>About</Typography>

              <div data-testid="div-jxfh" style={{ display: "flex", alignItems: "center", height: "100%" }}>

                <Grid2
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ ml: 15, pl: 15 }}
                >
                  <Grid2 size={{ xs: 12 }}>
                    <Box data-testid="Box-4x97" sx={{ width: '100%', maxWidth: 1500 }}>
                      <Box data-testid="Box-eyp4" sx={{ maxWidth: 600, ml: -6, pt: 2, mb: -2 }}>
                        <Typography data-testid="Typography-uq9s" variant="h5" gutterBottom align="left" sx={{ fontWeight: 'bold', color: colorConfigs.dashboard.dark_red }} >
                          {productName}
                        </Typography>
                      </Box>
                      <Table data-testid="Table-7ku4"
                        sx={{
                          maxWidth: 800,
                          align: "left",
                          ml: -8,
                          [`& .${tableCellClasses.root}`]: {
                            borderBottom: "none"
                          }
                        }}
                        border-collapse="collapse"
                      >
                        <TableRow data-testid="TableRow-axj4" style={{ borderBottom: 'none' }}>
                          <TableCell data-testid="TableCell-upma"><Typography data-testid="Typography-qlhq" variant="body1" gutterBottom> </Typography></TableCell>
                          <TableCell data-testid="TableCell-vnsq"><Typography data-testid="Typography-si79" variant="body1" gutterBottom> </Typography></TableCell>
                        </TableRow>
                        <TableRow data-testid="TableRow-wc2b" style={{ borderBottom: 'none' }}>
                          <TableCell data-testid="TableCell-kuda"><Typography data-testid="Typography-gnym" sx={{ fontWeight: 1000, color: colorConfigs.dashboard.dark_red }}>Version:</Typography></TableCell>
                          <TableCell data-testid="TableCell-ywp9"><Typography data-testid="Typography-0gx3" variant="body1" gutterBottom>{version}</Typography></TableCell>
                        </TableRow>
                        <TableRow data-testid="TableRow-p5gt" style={{ borderBottom: 'none' }}>
                          <TableCell data-testid="TableCell-jdr1"><img data-testid="img-dyu3" src={assets.images.ISOManufactureDate} alt="reficon" style={{ aspectRatio: 1 / 1 }} /></TableCell>
                          <TableCell data-testid="TableCell-sn0t"><Typography data-testid="Typography-4bwl" variant="body1" gutterBottom>{manufacturedate}</Typography></TableCell>
                        </TableRow>
                        <TableRow data-testid="TableRow-1n1f" style={{ borderBottom: 'none' }}>
                          <TableCell data-testid="TableCell-f6vn"><img data-testid="img-n2tz" src={assets.images.ISOManufacturedBy} alt="reficon" style={{ aspectRatio: 1 / 1, width: "33px" }} /></TableCell>
                          <TableCell data-testid="TableCell-4bu1">
                            <Typography data-testid="Typography-r273" variant="body1" gutterBottom>{address}</Typography>
                            <Typography variant="body1" gutterBottom>{address2}</Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow style={{ borderBottom: 'none' }}>
                          <TableCell>
                            <Typography>
                              <img src={assets.images.udi} style={{ width: "40px" }} />
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography>
                              {UDI}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </Table>
                      <Box data-testid="Box-ydht" sx={{ maxWidth: 600, ml: -6, pt: 2 }}>
                        <Typography data-testid="Typography-wbx6" variant="h5" gutterBottom align="left" sx={{ fontWeight: 'bold', color: colorConfigs.dashboard.dark_red }} >
                          Intended purpose
                        </Typography>
                        <Typography data-testid="Typography-9hyu" variant="body1" gutterBottom>
                          The web portal is a centralized software platform exclusively intended for use by the manufacturer for the configuration of test assay SKUs, including parameters and interpretation thresholds, to ensure compatibility with the OT-Scan® mobile application and the OralTox® device. The portal is not designed or authorized for use by app users or consumers.
                          <br />
                          <br />
                          The web portal facilitates the secure management and deployment of predefined test configurations to support OT-Scan® in its established intended use cases.
                        </Typography>
                        {/* <Typography data-testid="Typography-xsns" variant="body1" gutterBottom>
                          The app serves as a reader, providing its interpretation to healthcare workers or representatives of health programs as a basis for treatment. Results are transmitted to this cloud-based portal for real-time sharing with authorized stakeholders.
                        </Typography> */}
                        <br />
                      </Box>
                      <Table data-testid="Table-ptt5" sx={{
                        maxWidth: 400,
                        align: "left",
                        ml: -8,
                        [`& .${tableCellClasses.root}`]: {
                          borderBottom: "none"
                        }
                      }}>
                        <TableRow data-testid="TableRow-8dnv" style={{ borderBottom: 'none' }}>
                          <TableCell data-testid="TableCell-yn4h">
                            <RareButton data-testid="RareButton-cmja"
                              variant="outlined"

                            >
                              Terms and Conditions
                            </RareButton>
                          </TableCell>
                          <TableCell data-testid="TableCell-wdgx">
                            <RareButton data-testid="RareButton-7t7s"
                              variant="outlined"

                            >
                              Privacy Policy
                            </RareButton>
                          </TableCell>
                        </TableRow>
                      </Table>

                    </Box>
                  </Grid2>
                </Grid2>
              </div>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  ) : (null);
};
export default AboutPage;
